import { RankType } from "./configs";

const startPositions = {
  sidos: { x: 0, y: 0 },
  kyungiW: { x: 0, y: 3 },
  kyungiS: { x: 7, y: 5 },
  kyungiE: { x: 0, y: 10 },
  kwangwon: { x: 0, y: 12 },
  inchun: { x: 5, y: 2 },
  seoul: { x: 0, y: 6 },

  chungchengN: { x: 10, y: 2 },
  daejun: { x: 11, y: 4 },
  chungchengS: { x: 11, y: 7 },

  kyungsangN: { x: 11, y: 10 },
  kyungsangS: { x: 15, y: 7 },
  daegu: { x: 14, y: 9 },
  ulsan: { x: 15, y: 11 },
  busan: { x: 19, y: 9 },

  junraN: { x: 15, y: 2 },
  kwangju: { x: 17, y: 2 },
  junraS: { x: 17, y: 4 },
  jeju: { x: 22, y: 5 },
};

export const getBorderInfo = (text) => {
  const border = {
    left: false,
    top: false,
    right: false,
    bottom: false,
  };
  if (text.includes("l")) {
    border.left = true;
  }
  if (text.includes("t")) {
    border.top = true;
  }
  if (text.includes("r")) {
    border.right = true;
  }
  if (text.includes("b")) {
    border.bottom = true;
  }
  return border;
};

const unsoldParentGunguNameMap = new Map(
  [
    ["고양시 일산서구", "고양시"],
    ["고양시 일산동구", "고양시"],
    ["고양시 덕양구", "고양시"],
    ["부천시 원미구", "부천시"],
    ["부천시 소사구", "부천시"],
    ["안산시 상록구", "안산시"],
    ["안산시 단원구", "안산시"],
    ["안양시 만안구", "안양시"],
    ["안양시 동안구", "안양시"],
    ["성남시 분당구", "성남시"],
    ["성남시 중원구", "성남시"],
    ["성남시 수정구", "성남시"],
    ["용인시 처인구", "용인시"],
    ["용인시 기흥구", "용인시"],
    ["용인시 수지구", "용인시"],
    ["수원시 장안구", "수원시"],
    ["수원시 영통구", "수원시"],
    ["수원시 권선구", "수원시"],
    ["수원시 팔달구", "수원시"],
    ["천안시 서북구", "천안시"],
    ["천안시 동남구", "천안시"],
    ["청주시 청원구", "청주시"],
    ["청주시 상당구", "청주시"],
    ["청주시 흥덕구", "청주시"],
    ["청주시 서원구", "청주시"],
    ["포항시 북구", "포항시"],
    ["포항시 남구", "포항시"],
    ["창원시 의창구", "창원시"],
    ["창원시 마산회원구", "창원시"],
    ["창원시 성산구", "창원시"],
    ["창원시 마산합포구", "창원시"],
    ["창원시 진해구", "창원시"],
    ["전주시 덕진구", "전주시"],
    ["전주시 완산구", "전주시"],
  ].map(([name, parentName]) => [name, parentName]),
);

const unsoldTilePositionOverrides = new Map(
  [
    ["경기도:양주시", { dx: 1 }],
    ["경기도:동두천시", { dy: -1 }],
    ["경기도:하남시", { dx: 2 }],
    ["경기도:광주시", { dx: 2 }],
    ["경기도:이천시", { dx: -1 }],
    ["경상남도:진주시", { dx: 1 }],
    ["경상남도:김해시", { dx: 1 }],
    ["경상남도:양산시", { dx: 1 }],
    ["경상남도:사천시", { dx: 1 }],
    ["경상남도:창원시", { dx: 1 }],
    ["경상남도:통영시", { dx: -1 }],
    ["경상남도:거제시", { dx: -1 }],
    ["제주도:제주시", { dx: -1 }],
  ].map(([key, value]) => [key, value]),
);

const unsoldTileBorderOverrides = new Map(
  [
    ["경기도:동두천시", { thin: ["bottom"] }],
    ["경기도:양주시", { thick: ["right"], thin: ["top"] }],
    ["경기도:화성시", { thick: ["bottom"] }],
    ["경기도:평택시", { thick: ["left"] }],
    ["경기도:안양시", { thick: ["right"] }],
    ["경기도:안성시", { thick: ["right"] }],
    ["경기도:수원시", { thick: ["top", "bottom", "right"] }],
    ["경기도:과천시", { thick: ["left", "bottom"] }],
    ["경기도:이천시", { thick: ["left"], thin: ["top"] }],
    ["경기도:성남시", { thick: ["top"], thin: ["bottom"] }],
    ["충청남도:천안시", { thick: ["right"] }],
    ["충청남도:아산시", { thick: ["top"] }],
    ["충청북도:청주시", { thick: ["bottom", "right"] }],
    ["충청북도:제천시", { thick: ["bottom"] }],
    ["경상북도:칠곡군", { thick: ["left"] }],
    ["경상북도:경산시", { thick: ["right"] }],
    ["경상북도:김천시", { thin: ["right"] }],
    ["경상북도:경주시", { thin: ["left"] }],
    ["경상남도:진주시", { thin: ["right"] }],
    ["경상남도:양산시", { thin: ["left"] }],
    ["전라북도:전주시", { thick: ["right"] }],
  ].map(([key, value]) => [key, value]),
);

const applyBorderOverride = (region, override) => {
  if (!override) return region;
  const border = { ...(region.border ?? getBorderInfo("")) };
  const thinBorder = { ...(region.thinBorder ?? getBorderInfo("")) };
  for (const side of override.thick ?? []) {
    border[side] = true;
    thinBorder[side] = false;
  }
  for (const side of override.thin ?? []) {
    border[side] = false;
    thinBorder[side] = true;
  }
  return { ...region, border, thinBorder };
};

const sideToDelta = {
  left: { dx: 0, dy: -1, opposite: "right" },
  top: { dx: -1, dy: 0, opposite: "bottom" },
  right: { dx: 0, dy: 1, opposite: "left" },
  bottom: { dx: 1, dy: 0, opposite: "top" },
};

const sideOrder = ["top", "right", "bottom", "left"];

const applyPairedUnsoldBorderOverrides = (regions) => {
  const getAbsPosition = (region) => {
    const start = startPositions[region.group] ?? { x: 0, y: 0 };
    return {
      x: start.x + region.startX,
      y: start.y + region.startY,
    };
  };
  const keyOf = (region) => `${region.sidoName}:${region.name}`;
  const getSegmentKey = (region, side) => {
    const pos = getAbsPosition(region);
    if (side === "top") return `H:${pos.x}:${pos.y}`;
    if (side === "bottom") return `H:${pos.x + 1}:${pos.y}`;
    if (side === "left") return `V:${pos.x}:${pos.y}`;
    return `V:${pos.x}:${pos.y + 1}`;
  };
  const getThinOwnerKey = (segmentKey) => {
    const [direction, x, y] = segmentKey.split(":");
    // CSS 1px border가 양쪽 타일에서 동시에 그려지면 2px처럼 보이므로 한쪽만 얇은 선을 가진다.
    return direction === "H"
      ? `${segmentKey}:bottom:${Number(x) - 1}:${y}`
      : `${segmentKey}:right:${x}:${Number(y) - 1}`;
  };
  const thinSegmentKeys = new Set();
  const thickSegmentKeys = new Set();
  const cellMap = new Map(
    regions.map((region, index) => {
      const pos = getAbsPosition(region);
      return [`${pos.x}:${pos.y}`, index];
    }),
  );
  const nextRegions = regions.map((region) => ({ ...region }));

  regions.forEach((region, index) => {
    const override = unsoldTileBorderOverrides.get(keyOf(region));
    if (!override) return;
    const pos = getAbsPosition(region);
    for (const mode of ["thick", "thin"]) {
      for (const side of override[mode] ?? []) {
        const segmentKey = getSegmentKey(region, side);
        if (mode === "thick") {
          thickSegmentKeys.add(segmentKey);
        } else {
          thinSegmentKeys.add(segmentKey);
        }
        const delta = sideToDelta[side];
        const neighborIndex = cellMap.get(`${pos.x + delta.dx}:${pos.y + delta.dy}`);
        if (neighborIndex == null) continue;
        nextRegions[neighborIndex] = applyBorderOverride(
          nextRegions[neighborIndex],
          { [mode]: [delta.opposite] },
        );
      }
    }
    nextRegions[index] = applyBorderOverride(nextRegions[index], override);
  });

  return nextRegions.map((region) => {
    const border = { ...(region.border ?? getBorderInfo("")) };
    const thinBorder = { ...(region.thinBorder ?? getBorderInfo("")) };
    for (const side of sideOrder) {
      const segmentKey = getSegmentKey(region, side);
      const ownerKey = `${segmentKey}:${side}:${getAbsPosition(region).x}:${getAbsPosition(region).y}`;
      if (thinSegmentKeys.has(segmentKey)) {
        border[side] = false;
        thinBorder[side] = ownerKey === getThinOwnerKey(segmentKey);
      }
      if (thickSegmentKeys.has(segmentKey)) {
        border[side] = true;
        thinBorder[side] = false;
      }
    }
    return { ...region, border, thinBorder };
  });
};

/**
 * 미분양은 KOSIS 원천이 부모 군구 단위로 제공되는 지역이 있어 자식 구 타일을 부모 군구 타일로 접는다.
 */
const normalizeUnsoldParentGunguTiles = (regions) => {
  const seen = new Set();
  const result = [];
  for (const region of regions) {
    const parentName = unsoldParentGunguNameMap.get(region.name);
    const normalized = parentName
      ? {
          ...region,
          name: parentName,
          displayName: parentName,
        }
      : region;
    const key = `${normalized.sidoName}:${normalized.name}`;
    if (parentName && seen.has(key)) {
      continue;
    }
    const positionOverride = unsoldTilePositionOverrides.get(key);
    const positioned = positionOverride
      ? {
          ...normalized,
          startX: normalized.startX + (positionOverride.dx ?? 0),
          startY: normalized.startY + (positionOverride.dy ?? 0),
      }
      : normalized;
    seen.add(key);
    result.push(positioned);
  }
  return applyPairedUnsoldBorderOverrides(result);
};

export const getRegionTilemapConfig = (regionType = RankType.PRICE_INDEX) => {
  let regions = [];
  let group = "sidos";
  const highLevel = true;
  const sidoStart = 5;
  // KB 주간 지수가 신설 인천 군구를 제공하기 시작했으므로 가격지수도 활성 지역명을 사용한다.
  const useLegacyIncheonKbRegions = false;
  regions.push(
    ...[
      {
        group,
        name: "전국",
        displayName: "전국",
        startX: 0,
        startY: 0,
        sidoName: "전국",
        border: getBorderInfo("ltr"),
        highLevel,
      },
      {
        group,
        name: "서울시",
        displayName: "서울시",
        startX: 1,
        startY: 0,
        sidoName: "서울시",
        border: getBorderInfo("ltr"),
      },
      // {
      //   group,
      //   name: "강북14개구",
      //   displayName: "강북14개구",
      //   startX: 2,
      //   startY: 0,
      //   sidoName: "강북14개구",
      //   border: getBorderInfo("ltr"),
      //   highLevel,
      // },
      // {
      //   group,
      //   name: "강남11개구",
      //   displayName: "강남11개구",
      //   startX: 3,
      //   startY: 0,
      //   sidoName: "강남11개구",
      //   border: getBorderInfo("ltr"),
      //   highLevel,
      // },
      {
        group,
        name: "수도권",
        displayName: "수도권",
        startX: 2,
        startY: 0,
        sidoName: "수도권",
        border: getBorderInfo("ltr"),
        highLevel,
      },
      {
        group,
        name: "6개광역시",
        displayName: "6개광역시",
        startX: 3,
        startY: 0,
        sidoName: "6개광역시",
        border: getBorderInfo("ltr"),
        highLevel,
      },
      {
        group,
        name: "기타지방",
        displayName: "기타지방",
        startX: 4,
        startY: 0,
        sidoName: "기타지방",
        border: getBorderInfo("ltr"),
        highLevel,
      },
      {
        group,
        name: "경기도",
        displayName: "경기도",
        startX: sidoStart + 0,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "인천시",
        displayName: "인천시",
        startX: sidoStart + 1,
        startY: 0,
        sidoName: "인천시",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "세종시",
        displayName: "세종시",
        startX: sidoStart + 2,
        startY: 0,
        sidoName: "세종시",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "대전시",
        displayName: "대전시",
        startX: sidoStart + 3,
        startY: 0,
        sidoName: "대전시",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "대구시",
        displayName: "대구시",
        startX: sidoStart + 4,
        startY: 0,
        sidoName: "대구시",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "부산시",
        displayName: "부산시",
        startX: sidoStart + 5,
        startY: 0,
        sidoName: "부산시",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "울산시",
        displayName: "울산시",
        startX: sidoStart + 6,
        startY: 0,
        sidoName: "울산시",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "전남광주시",
        displayName: "전남광주시",
        startX: sidoStart + 7,
        startY: 0,
        sidoName: "전남광주시",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "제주도",
        displayName: "제주도",
        startX: sidoStart + 8,
        startY: 0,
        sidoName: "제주도",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "충청북도",
        displayName: "충청북도",
        startX: sidoStart + 9,
        startY: 0,
        sidoName: "충청북도",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "충청남도",
        displayName: "충청남도",
        startX: sidoStart + 10,
        startY: 0,
        sidoName: "충청남도",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "강원도",
        displayName: "강원도",
        startX: sidoStart + 11,
        startY: 0,
        sidoName: "강원도",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "경상남도",
        displayName: "경상남도",
        startX: sidoStart + 12,
        startY: 0,
        sidoName: "경상남도",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "경상북도",
        displayName: "경상북도",
        startX: sidoStart + 13,
        startY: 0,
        sidoName: "경상북도",
        border: getBorderInfo("ltr"),
      },
      {
        group,
        name: "전라북도",
        displayName: "전라북도",
        startX: sidoStart + 14,
        startY: 0,
        sidoName: "전라북도",
        border: getBorderInfo("ltrb"),
      },
    ]
  );
  group = "kyungiW";
  regions.push(
    ...[
      {
        group,
        name: "파주시",
        displayName: "파주시",
        startX: 0,
        startY: -1,
        sidoName: "경기도",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "양주시",
        displayName: "양주시",
        startX: 0,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "동두천시",
        displayName: "동두천시",
        startX: 0,
        startY: 1,
        sidoName: "경기도",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "고양시 일산서구",
        displayName: "일산서구",
        startX: 1,
        startY: -1,
        sidoName: "경기도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "고양시 일산동구",
        displayName: "일산동구",
        startX: 1,
        startY: 0,
        sidoName: "경기도",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "김포시",
        displayName: "김포시",
        startX: 2,
        startY: -1,
        sidoName: "경기도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "시흥시",
        displayName: "시흥시",
        startX: 3,
        startY: -1,
        sidoName: "경기도",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "광명시",
        displayName: "광명시",
        startX: 3,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("rb"),
      },
    ]
  );
  if (
    regionType === RankType.REAL_PRICE ||
    regionType === RankType.SALE_COUNT
  ) {
    regions.push(
      ...[
        {
          group,
          name: "고양시 덕양구",
          displayName: "고양덕양구",
          startX: 1,
          startY: 1,
          sidoName: "경기도",
          border: getBorderInfo("r"),
          thinBorder: getBorderInfo("b"),
        },

        {
          group,
          name: "부천시 원미구",
          displayName: "부천원미구",
          startX: 2,
          startY: 0,
          sidoName: "경기도",
          thinBorder: getBorderInfo("br"),
        },
        {
          group,
          name: "부천시 소사구",
          displayName: "부천소사구",
          startX: 2,
          startY: 1,
          sidoName: "경기도",
          border: getBorderInfo("b"),
        },
      ]
    );
  } else {
    regions.push(
      ...[
        {
          group,
          name: "고양시 덕양구",
          displayName: "고양덕양구",
          startX: 1,
          startY: 1,
          sidoName: "경기도",
          border: getBorderInfo("rb"),
        },
        {
          group,
          name: "부천시",
          displayName: "부천시",
          startX: 2,
          startY: 0,
          sidoName: "경기도",
          border: getBorderInfo("r"),
          thinBorder: getBorderInfo("b"),
        },
      ]
    );
  }
  group = "kyungiS";
  regions.push(
    ...[
      {
        group,
        name: "군포시",
        displayName: "군포시",
        startX: 0,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "안산시 상록구",
        displayName: "안산상록구",
        startX: 0,
        startY: 1,
        sidoName: "경기도",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "안양시 만안구",
        displayName: "안양만안구",
        startX: 0,
        startY: 2,
        sidoName: "경기도",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "안양시 동안구",
        displayName: "안양동안구",
        startX: 0,
        startY: 3,
        sidoName: "경기도",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "과천시",
        displayName: "과천시",
        startX: 0,
        startY: 4,
        sidoName: "경기도",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "성남시 분당구",
        displayName: "성남분당구",
        startX: 0,
        startY: 5,
        sidoName: "경기도",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("tr"),
      },
      {
        group,
        name: "용인시 처인구",
        displayName: "용인처인구",
        startX: 0,
        startY: 6,
        sidoName: "경기도",
        border: getBorderInfo("rb"),
        thinBorder: getBorderInfo("t"),
      },
      {
        group,
        name: "성남시 중원구",
        displayName: "성남중원구",
        startX: -1,
        startY: 5,
        sidoName: "경기도",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "용인시 기흥구",
        displayName: "용인기흥구",
        startX: -1,
        startY: 6,
        sidoName: "경기도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("t"),
      },
      {
        group,
        name: "안산시 단원구",
        displayName: "안산단원구",
        startX: 2,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("tr"),
      },
      {
        group,
        name: "화성시",
        displayName: "화성시",
        startX: 1,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "오산시",
        displayName: "오산시",
        startX: 1,
        startY: 1,
        sidoName: "경기도",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "의왕시",
        displayName: "의왕시",
        startX: 1,
        startY: 2,
        sidoName: "경기도",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "수원시 장안구",
        displayName: "수원장안구",
        startX: 1,
        startY: 3,
        sidoName: "경기도",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "수원시 영통구",
        displayName: "수원영통구",
        startX: 1,
        startY: 4,
        sidoName: "경기도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "평택시",
        displayName: "평택시",
        startX: 2,
        startY: 1,
        sidoName: "경기도",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "안성시",
        displayName: "안성시",
        startX: 2,
        startY: 2,
        sidoName: "경기도",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "수원시 권선구",
        displayName: "수원권선구",
        startX: 2,
        startY: 3,
        sidoName: "경기도",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "수원시 팔달구",
        displayName: "수원팔달구",
        startX: 2,
        startY: 4,
        sidoName: "경기도",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "이천시",
        displayName: "이천시",
        startX: 2,
        startY: 5,
        sidoName: "경기도",
        border: getBorderInfo("trb"),
      },
    ]
  );
  group = "kyungiE";
  regions.push(
    ...[
      {
        group,
        name: "의정부시",
        displayName: "의정부시",
        startX: 0,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("ltr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "남양주시",
        displayName: "남양주시",
        startX: 1,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("lr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "구리시",
        displayName: "구리시",
        startX: 2,
        startY: 0,
        sidoName: "경기도",
        border: getBorderInfo("lrb"),
      },
      {
        group,
        name: "하남시",
        displayName: "하남시",
        startX: 3,
        startY: 1,
        sidoName: "경기도",
        border: getBorderInfo("ltr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "광주시",
        displayName: "광주시",
        startX: 4,
        startY: 1,
        sidoName: "경기도",
        border: getBorderInfo("lr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "성남시 수정구",
        displayName: "성남수정구",
        startX: 5,
        startY: 1,
        sidoName: "경기도",
        border: getBorderInfo("lr"),
      },
    ]
  );
  group = "inchun";
  regions.push(
    ...[
      {
        group,
        name: useLegacyIncheonKbRegions ? "서구" : "검단구",
        displayName: useLegacyIncheonKbRegions ? "인천서구" : "인천검단구",
        startX: 0,
        startY: 0,
        sidoName: "인천시",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: useLegacyIncheonKbRegions ? "동구" : "제물포구",
        displayName: useLegacyIncheonKbRegions ? "인천동구" : "인천제물포구",
        startX: 0,
        startY: 1,
        sidoName: "인천시",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: useLegacyIncheonKbRegions ? "중구" : "영종구",
        displayName: useLegacyIncheonKbRegions ? "인천중구" : "인천영종구",
        startX: 1,
        startY: 0,
        sidoName: "인천시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "계양구",
        displayName: "인천계양구",
        startX: 1,
        startY: 1,
        sidoName: "인천시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "미추홀구",
        displayName: "인천미추홀구",
        startX: 2,
        startY: 0,
        sidoName: "인천시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "부평구",
        displayName: "인천부평구",
        startX: 2,
        startY: 1,
        sidoName: "인천시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "연수구",
        displayName: "인천연수구",
        startX: 3,
        startY: 0,
        sidoName: "인천시",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "남동구",
        displayName: "인천남동구",
        startX: 3,
        startY: 1,
        sidoName: "인천시",
        border: getBorderInfo("br"),
      },
    ]
  );
  group = "seoul";
  regions.push(
    ...[
      {
        group,
        name: "강북구",
        displayName: "강북구",
        startX: 0,
        startY: 0,
        sidoName: "서울시",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "도봉구",
        displayName: "도봉구",
        startX: 0,
        startY: 1,
        sidoName: "서울시",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "노원구",
        displayName: "노원구",
        startX: 0,
        startY: 2,
        sidoName: "서울시",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "은평구",
        displayName: "은평구",
        startX: 1,
        startY: 0,
        sidoName: "서울시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "성북구",
        displayName: "성북구",
        startX: 1,
        startY: 1,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "중랑구",
        displayName: "중랑구",
        startX: 1,
        startY: 2,
        sidoName: "서울시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "마포구",
        displayName: "마포구",
        startX: 2,
        startY: -1,
        sidoName: "서울시",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "서대문구",
        displayName: "서대문구",
        startX: 2,
        startY: 0,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "종로구",
        displayName: "종로구",
        startX: 2,
        startY: 1,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "동대문구",
        displayName: "동대문구",
        startX: 2,
        startY: 2,
        sidoName: "서울시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "강서구",
        displayName: "강서구",
        startX: 3,
        startY: -1,
        sidoName: "서울시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "용산구",
        displayName: "용산구",
        startX: 3,
        startY: 0,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "중구",
        displayName: "중구",
        startX: 3,
        startY: 1,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "성동구",
        displayName: "성동구",
        startX: 3,
        startY: 2,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "광진구",
        displayName: "광진구",
        startX: 3,
        startY: 3,
        sidoName: "서울시",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "양천구",
        displayName: "양천구",
        startX: 4,
        startY: -1,
        sidoName: "서울시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "영등포구",
        displayName: "영등포구",
        startX: 4,
        startY: 0,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "동작구",
        displayName: "동작구",
        startX: 4,
        startY: 1,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "송파구",
        displayName: "송파구",
        startX: 4,
        startY: 2,
        sidoName: "서울시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "강동구",
        displayName: "강동구",
        startX: 4,
        startY: 3,
        sidoName: "서울시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "구로구",
        displayName: "구로구",
        startX: 5,
        startY: -1,
        sidoName: "서울시",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "금천구",
        displayName: "금천구",
        startX: 5,
        startY: 0,
        sidoName: "서울시",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "관악구",
        displayName: "관악구",
        startX: 5,
        startY: 1,
        sidoName: "서울시",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "서초구",
        displayName: "서초구",
        startX: 5,
        startY: 2,
        sidoName: "서울시",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "강남구",
        displayName: "강남구",
        startX: 5,
        startY: 3,
        sidoName: "서울시",
        border: getBorderInfo("br"),
      },
    ]
  );
  group = "kwangwon";
  regions.push(
    ...[
      {
        group,
        name: "춘천시",
        displayName: "춘천시",
        startX: 0,
        startY: 0,
        sidoName: "강원도",
        border: getBorderInfo("ltr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "강릉시",
        displayName: "강릉시",
        startX: 1,
        startY: 0,
        sidoName: "강원도",
        border: getBorderInfo("lr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "원주시",
        displayName: "원주시",
        startX: 2,
        startY: 0,
        sidoName: "강원도",
        border: getBorderInfo("lbr"),
      },
    ]
  );
  group = "chungchengN";
  regions.push(
    ...[
      {
        group,
        name: "천안시 서북구",
        displayName: "천안서북구",
        startX: 0,
        startY: 0,
        sidoName: "충청남도",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "천안시 동남구",
        displayName: "천안동남구",
        startX: 0,
        startY: 1,
        sidoName: "충청남도",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "당진시",
        displayName: "당진시",
        startX: 1,
        startY: 0,
        sidoName: "충청남도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "아산시",
        displayName: "아산시",
        startX: 1,
        startY: 1,
        sidoName: "충청남도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "서산시",
        displayName: "서산시",
        startX: 2,
        startY: 0,
        sidoName: "충청남도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "공주시",
        displayName: "공주시",
        startX: 2,
        startY: 1,
        sidoName: "충청남도",
        border: getBorderInfo("r"),

        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "논산시",
        displayName: "논산시",
        startX: 3,
        startY: 0,
        sidoName: "충청남도",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "계룡시",
        displayName: "계룡시",
        startX: 3,
        startY: 1,
        sidoName: "충청남도",
        border: getBorderInfo("br"),
        thinBorder: getBorderInfo("r"),
      },
    ]
  );
  group = "daejun";
  regions.push(
    ...[
      {
        group,
        name: "세종시",
        displayName: "세종시",
        startX: 0,
        startY: 0,
        sidoName: "세종시",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "대덕구",
        displayName: "대전대덕구",
        startX: 0,
        startY: 1,
        sidoName: "대전시",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "유성구",
        displayName: "대전유성구",
        startX: 1,
        startY: 0,
        sidoName: "대전시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "중구",
        displayName: "대전중구",
        startX: 1,
        startY: 1,
        sidoName: "대전시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "서구",
        displayName: "대전서구",
        startX: 2,
        startY: 0,
        sidoName: "대전시",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "동구",
        displayName: "대전동구",
        startX: 2,
        startY: 1,
        sidoName: "대전시",
        border: getBorderInfo("br"),
      },
    ]
  );
  group = "chungchengS";
  regions.push(
    ...[
      {
        group,
        name: "충주시",
        displayName: "충주시",
        startX: 0,
        startY: 0,
        sidoName: "충청북도",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "제천시",
        displayName: "제천시",
        startX: 0,
        startY: 1,
        sidoName: "충청북도",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "청주시 청원구",
        displayName: "청주청원구",
        startX: 1,
        startY: 0,
        sidoName: "충청북도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "청주시 상당구",
        displayName: "청주상당구",
        startX: 1,
        startY: 1,
        sidoName: "충청북도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "청주시 흥덕구",
        displayName: "청주흥덕구",
        startX: 2,
        startY: 0,
        sidoName: "충청북도",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "청주시 서원구",
        displayName: "청주서원구",
        startX: 2,
        startY: 1,
        sidoName: "충청북도",
        border: getBorderInfo("br"),
      },
    ]
  );
  group = "kyungsangN";
  regions.push(
    ...[
      {
        group,
        name: "구미시",
        displayName: "구미시",
        startX: 0,
        startY: 0,
        sidoName: "경상북도",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "김천시",
        displayName: "김천시",
        startX: 0,
        startY: 1,
        sidoName: "경상북도",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "경주시",
        displayName: "경주시",
        startX: 0,
        startY: 2,
        sidoName: "경상북도",
        border: getBorderInfo("trb"),
      },
      {
        group,
        name: "칠곡군",
        displayName: "칠곡군",
        startX: 1,
        startY: -1,
        sidoName: "경상북도",
        border: getBorderInfo("tb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "안동시",
        displayName: "안동시",
        startX: 1,
        startY: 0,
        sidoName: "경상북도",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "포항시 북구",
        displayName: "포항북구",
        startX: 1,
        startY: 1,
        sidoName: "경상북도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "경산시",
        displayName: "경산시",
        startX: 2,
        startY: 1,
        sidoName: "경상북도",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "포항시 남구",
        displayName: "포항남구",
        startX: 2,
        startY: 2,
        sidoName: "경상북도",
        border: getBorderInfo("brt"),
      },
    ]
  );
  group = "daegu";
  regions.push(
    ...[
      {
        group,
        name: "북구",
        displayName: "대구북구",
        startX: 0,
        startY: 0,
        sidoName: "대구시",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "동구",
        displayName: "대구동구",
        startX: 0,
        startY: 1,
        sidoName: "대구시",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "서구",
        displayName: "대구서구",
        startX: 1,
        startY: 0,
        sidoName: "대구시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "수성구",
        displayName: "대구수성구",
        startX: 1,
        startY: 1,
        sidoName: "대구시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "달서구",
        displayName: "대구달서구",
        startX: 2,
        startY: 0,
        sidoName: "대구시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "중구",
        displayName: "대구중구",
        startX: 2,
        startY: 1,
        sidoName: "대구시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "달성군",
        displayName: "대구달성군",
        startX: 3,
        startY: 0,
        sidoName: "대구시",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "남구",
        displayName: "대구남구",
        startX: 3,
        startY: 1,
        sidoName: "대구시",
        border: getBorderInfo("br"),
      },
    ]
  );
  group = "ulsan";
  regions.push(
    ...[
      {
        group,
        name: "울주군",
        displayName: "울산울주군",
        startX: 0,
        startY: 0,
        sidoName: "울산시",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "북구",
        displayName: "울산북구",

        startX: 0,
        startY: 1,
        sidoName: "울산시",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "중구",
        displayName: "울산중구",
        startX: 1,
        startY: 0,
        sidoName: "울산시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "남구",
        displayName: "울산남구",
        startX: 1,
        startY: 1,
        sidoName: "울산시",
        border: getBorderInfo("br"),
      },
      {
        group,
        name: "동구",
        displayName: "울산동구",
        startX: 2,
        startY: 0,
        sidoName: "울산시",
        border: getBorderInfo("br"),
      },
    ]
  );
  group = "busan";
  regions.push(
    ...[
      {
        group,
        name: "북구",
        displayName: "부산북구",
        startX: 0,
        startY: 0,
        sidoName: "부산시",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "부산진구",
        displayName: "부산진구",
        startX: 0,
        startY: 1,
        sidoName: "부산시",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "금정구",
        displayName: "부산금정구",
        startX: 0,
        startY: 2,
        sidoName: "부산시",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "기장군",
        displayName: "부산기장군",
        startX: 0,
        startY: 3,
        sidoName: "부산시",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "강서구",
        displayName: "부산강서구",
        startX: 1,
        startY: 0,
        sidoName: "부산시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "서구",
        displayName: "부산서구",
        startX: 1,
        startY: 1,
        sidoName: "부산시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "동래구",
        displayName: "부산동래구",
        startX: 1,
        startY: 2,
        sidoName: "부산시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "해운대구",
        displayName: "부산해운대구",
        startX: 1,
        startY: 3,
        sidoName: "부산시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "사상구",
        displayName: "부산사상구",
        startX: 2,
        startY: 0,
        sidoName: "부산시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "동구",
        displayName: "부산동구",
        startX: 2,
        startY: 1,
        sidoName: "부산시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "연제구",
        displayName: "부산연제구",
        startX: 2,
        startY: 2,
        sidoName: "부산시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "수영구",
        displayName: "부산수영구",
        startX: 2,
        startY: 3,
        sidoName: "부산시",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "사하구",
        displayName: "부산사하구",
        startX: 3,
        startY: 0,
        sidoName: "부산시",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "중구",
        displayName: "부산중구",
        startX: 3,
        startY: 1,
        sidoName: "부산시",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "영도구",
        displayName: "부산영도구",
        startX: 3,
        startY: 2,
        sidoName: "부산시",
        border: getBorderInfo("b"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "남구",
        displayName: "부산남구",
        startX: 3,
        startY: 3,
        sidoName: "부산시",
        border: getBorderInfo("br"),
      },
    ]
  );
  group = "kyungsangS";
  regions.push(
    ...[
      {
        group,
        name: "김해시",
        displayName: "김해시",
        startX: 0,
        startY: 0,
        sidoName: "경상남도",
        border: getBorderInfo("ltr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "진주시",
        displayName: "진주시",
        startX: 1,
        startY: -1,
        sidoName: "경상남도",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "양산시",
        displayName: "양산시",
        startX: 1,
        startY: 0,
        sidoName: "경상남도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "사천시",
        displayName: "사천시",
        startX: 2,
        startY: -1,
        sidoName: "경상남도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "창원시 의창구",
        displayName: "창원의창구",
        startX: 2,
        startY: 0,
        sidoName: "경상남도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "창원시 마산회원구",
        displayName: "마산회원구",
        startX: 3,
        startY: -1,
        sidoName: "경상남도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "창원시 성산구",
        displayName: "창원성산구",
        startX: 3,
        startY: 0,
        sidoName: "경상남도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "창원시 마산합포구",
        displayName: "마산합포구",
        startX: 4,
        startY: -1,
        sidoName: "경상남도",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "창원시 진해구",
        displayName: "창원진해구",
        startX: 4,
        startY: 0,
        sidoName: "경상남도",
        border: getBorderInfo("r"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "통영시",
        displayName: "통영시",
        startX: 5,
        startY: -1,
        sidoName: "경상남도",
        border: getBorderInfo("lb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "거제시",
        displayName: "거제시",
        startX: 5,
        startY: 0,
        sidoName: "경상남도",
        border: getBorderInfo("br"),
      },
    ]
  );
  group = "junraN";
  regions.push(
    ...[
      {
        group,
        name: "군산시",
        displayName: "군산시",
        startX: 0,
        startY: 0,
        sidoName: "전라북도",
        border: getBorderInfo("ltb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "익산시",
        displayName: "익산시",
        startX: 0,
        startY: 1,
        sidoName: "전라북도",
        border: getBorderInfo("tb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "전주시 덕진구",
        displayName: "전주덕진구",
        startX: 0,
        startY: 2,
        sidoName: "전라북도",
        border: getBorderInfo("tb"),
        thinBorder: getBorderInfo("r"),
      },
      {
        group,
        name: "전주시 완산구",
        displayName: "전주완산구",
        startX: 0,
        startY: 3,
        sidoName: "전라북도",
        border: getBorderInfo("tbr"),
      },
    ]
  );
  group = "kwangju";
  regions.push(
    ...[
      {
        group,
        name: "광산구",
        displayName: "광주광산구",
        startX: 0,
        startY: 0,
        sidoName: "전남광주시",
        border: getBorderInfo("lt"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "북구",
        displayName: "광주북구",
        startX: 0,
        startY: 1,
        sidoName: "전남광주시",
        border: getBorderInfo("tr"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "서구",
        displayName: "광주서구",
        startX: 1,
        startY: 0,
        sidoName: "전남광주시",
        border: getBorderInfo("l"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "동구",
        displayName: "광주동구",
        startX: 1,
        startY: 1,
        sidoName: "전남광주시",
        border: getBorderInfo("br"),
      },
      {
        group,
        name: "남구",
        displayName: "광주남구",
        startX: 2,
        startY: 0,
        sidoName: "전남광주시",
        border: getBorderInfo("lbr"),
      },
    ]
  );
  group = "junraS";
  regions.push(
    ...[
      {
        group,
        name: "순천시",
        displayName: "순천시",
        startX: 0,
        startY: 0,
        sidoName: "전남광주시",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "광양시",
        displayName: "광양시",
        startX: 0,
        startY: 1,
        sidoName: "전남광주시",
        border: getBorderInfo("t"),
        thinBorder: getBorderInfo("b"),
      },
      {
        group,
        name: "목포시",
        displayName: "목포시",
        startX: 1,
        startY: 0,
        sidoName: "전남광주시",
        thinBorder: getBorderInfo("br"),
      },
      {
        group,
        name: "여수시",
        displayName: "여수시",
        startX: 1,
        startY: 1,
        sidoName: "전남광주시",
        border: getBorderInfo("b"),
      },
      {
        group,
        name: "무안군",
        displayName: "무안군",
        startX: 2,
        startY: 0,
        sidoName: "전남광주시",
        border: getBorderInfo("lbr"),
      },
    ]
  );
  group = "jeju";
  regions.push(
    ...[
      {
        group,
        name: "제주시",
        displayName: "제주시",
        startX: 0,
        startY: 0,
        sidoName: "제주도",
        border: getBorderInfo("lbrt"),
      },
    ]
  );

  if (regionType === RankType.UNSOLD) {
    regions = normalizeUnsoldParentGunguTiles(regions);
  }

  regions.forEach((region) => {
    const start = startPositions[region.group];
    region.x = start.x + region.startX;
    region.y = start.y + region.startY;
  });
  return regions;
};
